import React, { useEffect } from "react"
import { addToGarage, removeFromGarage } from "store/garage/actions"
import { useSelector } from "react-redux"

import SimplePage from "layouts/SimplePage"
import AuthGuard from "./AuthGuard"
import ProfileGuard from "./ProfileGuard"
import LoginForm from "./LoginForm"
import { useActions } from "store/utils"
import { logOut, clearIntent } from "store/app/actions"
import { storeIntent } from "store/app/actions"

import Button from "components/Button"

import "./MyGarage.sass"
import CarButton from "components/CarButton"
import GarageFetcher from "./GarageFetcher"
import ProfileFetcher from "./ProfileFetcher"
import { isReactEnvironment } from "utils"

import { ReactComponent as CloseSVG } from "assets/Icon/Close.svg"
import ContractsFetcher from "./ContractsFetcher"
import SettingsPage from "layouts/SettingsPage"
import { useNavigate } from "react-router-dom"

export default function MyGarage() {
  const actions = useActions({
    logOut: () => logOut(),
    addToGarage: (entry) => addToGarage(entry),
    removeFromGarage: (id) => removeFromGarage(id),
    storeIntent: (action, payload) => storeIntent(action, payload),
    clearIntent: () => clearIntent(),
  })

  const { entries, isLoaded, isLoading } = useSelector((state) => state.garage)
  const { entry: profile } = useSelector((state) => state.profile)

  async function handleLogout(e) {
    e.preventDefault()
    await actions.logOut()
    // redirect("/")
  }

  const { authenticated } = useSelector((state) => state.app)
  const { storedIntent } = useSelector((state) => state.app)

  useEffect(() => {
    async function handleStoredIntent() {
      await actions.addToGarage(storedIntent.payload)
      await actions.clearIntent()
    }

    if (
      authenticated &&
      isLoaded &&
      !isLoading &&
      !!storedIntent &&
      storedIntent.type === "ADD_TO_GARAGE"
    ) {
      handleStoredIntent()
    }
  }, [actions, authenticated, isLoaded, isLoading, storedIntent])

  const navigate = useNavigate()
  function redirect(to) {
    if (isReactEnvironment) {
      navigate(to)
    } else {
      window.location.pathname = to
    }
  }

  async function handleContract(e, carData) {
    e && e.preventDefault()

    await actions.storeIntent("MAKE_CONTRACT", carData)
    redirect(`/kupoprodajna-pogodba/`)
  }

  async function handleUnparking(e, id) {
    e.preventDefault()

    if (id) await actions.removeFromGarage(id)
  }

  return (
    <AuthGuard placeholder={<LoginRequired />}>
      <ProfileGuard>
        <SettingsPage className="MyGarage">
          <ProfileFetcher />
          <GarageFetcher />
          <ContractsFetcher />

          <h1>Moja garaža</h1>
          <p>
            V garažo lahko shranjujete svoja vozila in dodatne podatke, ki jih
            pridobite skozi Avtolog.
          </p>

          <div className="entries">
            {!isLoaded && isLoading && <p>Nalagam ...</p>}

            {entries.map((entry, i) => (
              <CarButton {...entry} key={`entry-${i}`}>
                <Button onClick={(e) => handleUnparking(e, entry.id)} isDanger>
                  <CloseSVG />
                </Button>
                <Button onClick={(e) => handleContract(e, entry)}>
                  Pogodba
                </Button>
              </CarButton>
            ))}

            {isLoaded && entries.length === 0 && (
              <h4>Trenutno v garaži nimate parkiranih vozil.</h4>
            )}
          </div>

          <p className="actions">
            <span>
              {profile.first_name} {profile.last_name}
            </span>
            <Button onClick={handleLogout}>Odjavi me</Button>
          </p>
        </SettingsPage>
      </ProfileGuard>
    </AuthGuard>
  )
}

function LoginRequired() {
  return (
    <SimplePage className="MyGarage">
      <h1>Moja garaža</h1>
      <p>
        V garažo lahko shranjujete svoja vozila in dodatne podatke, ki jih
        pridobite skozi Avtolog.
        <br />
        Za dostop do garaže morate biti prijavljeni.
      </p>
      <h2 className="Login">Prijava</h2>
      <LoginForm redirect="/moja-garaza/" />
    </SimplePage>
  )
}
